<script lang="jsx">
export default {
  functional: true,
  props: {
    title: String,
  },
  render(h, context) {
    return <div class="vu-title">{context.props.title}</div>;
  }
};
</script>

<style scoped lang="scss">
.vu-title {
  color: $global-default-primary;
  font-size: 20px;
  height: 24px;
  line-height: 24px;
  padding-left: 12px;
  border-left: 4px solid  $global-default-primary;
}

</style>